import React from "react";
import "./hero.css";

function Hero() {
  return (
    <section className="hero">
      {/* Left Side Image */}
      <div className="hero-left">
        <img src="/images/hero.jpg" alt="Wedding Outfit" />
      </div>

      {/* Right Side Content */}
      <div className="hero-right">
        <h1>MUHURTMEDH</h1>
        <h3>Custom Wedding Outfits</h3>
        <p>
          Celebrate your special day with elegance. At <strong>Muhurtmedh</strong>, 
          we design custom wedding outfits that reflect your unique style, 
          tradition, and personality.
        </p>
        <a href="#collections">
          <button className="hero-btn">Explore Collection</button>
        </a>
      </div>
    </section>
  );
}

export default Hero;
